import { Provider } from '@angular/core';
import { TaskHierarhyHttpService } from './abstract';
import { TaskHierarchyHttpServiceImpl } from './task-hierarhy-http-service';

export const TaskHierarhyHttpProvider: Provider = {
	provide: TaskHierarhyHttpService,
	useClass: TaskHierarchyHttpServiceImpl,
};
